import { createSlice } from "@reduxjs/toolkit"
import { addUser, getUsers } from "./api"

export const usersSlice = createSlice({
    name: 'users',
    initialState: {
        users: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUsers.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(getUsers.fulfilled, (state, action) => {
                state.isLoading = false
                state.users = action.payload
            })
            .addCase(getUsers.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(addUser.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(addUser.fulfilled, (state, action) => {
                state.isLoading = false
                state.users.push(action.payload)
            })
            .addCase(addUser.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
    }
})

export default usersSlice.reducer